module.exports = __webpack_public_path__ + "static/media/bankChange.77b64d78.svg";